import { motion } from "framer-motion";
import { AlertTriangle, ShoppingBasket, Ticket } from "lucide-react";
import { PHASE_TIPS, formatMoney } from "@/lib/budget";

export const PhaseSpend = ({ phase, currency, careAmount }) => (
  <motion.div layout className={`relative flex flex-col rounded-[1.5rem] border p-6 ${phase.id === "luteal" ? "border-[#8C5A6B]/40 bg-[#F6ECEE]" : "border-[#C86D51]/15 bg-[#FDFBF7]"}`}
    data-testid={`budget-phase-${phase.id}`}>
    <div className="flex items-center justify-between">
      <span className="font-serif text-xl italic" style={{ color: phase.color }}>{phase.name}</span>
      <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#7A665C]">Days {phase.days[0]}–{phase.days[1]}</span>
    </div>
    <p className="mt-4 font-serif text-4xl text-[#2C221E]" data-testid={`budget-phase-${phase.id}-amount`}>{formatMoney(phase.amount, currency)}</p>
    <p className="text-xs text-[#6B5A52]">everyday spending · about {formatMoney(phase.perDay, currency)} a day</p>
    {phase.id === "menstrual" && careAmount > 0 && (
      <p className="mt-2 text-xs font-medium text-[#9E4429]">+ {formatMoney(careAmount, currency)} period & self-care set aside</p>
    )}
    <div className="mt-4 grid grid-cols-2 gap-2">
      <span className="rounded-xl bg-[#F7EFD9] px-3 py-2 text-xs text-[#5C4A42]" data-testid={`budget-phase-${phase.id}-food`}>
        <ShoppingBasket className="mb-1 h-3.5 w-3.5 text-[#9A7A2E]" />Food <b className="block text-sm text-[#2C221E]">{formatMoney(phase.food, currency)}</b>
      </span>
      <span className="rounded-xl bg-[#E6EDF2] px-3 py-2 text-xs text-[#5C4A42]" data-testid={`budget-phase-${phase.id}-activities`}>
        <Ticket className="mb-1 h-3.5 w-3.5 text-[#4D6E87]" />Activities <b className="block text-sm text-[#2C221E]">{formatMoney(phase.activities, currency)}</b>
      </span>
    </div>
    {phase.id === "luteal" && (
      <span className="mt-3 inline-flex w-fit items-center gap-1.5 rounded-full bg-[#8C5A6B] px-3 py-1 text-[11px] font-semibold text-[#FBF5EE]" data-testid="budget-luteal-warning">
        <AlertTriangle className="h-3.5 w-3.5" /> Spending often rises
      </span>
    )}
    <p className="mt-4 text-sm leading-relaxed text-[#3D302B]">{PHASE_TIPS[phase.id]}</p>
  </motion.div>
);
